import style from "./FAQGenerator.module.scss";
import { useRouter } from "next/router";
import ArrowIcon from "../../../public/remove_back/magic_bg/arrow.svg";
import { useState } from "react";
import getFaqLocales from "../../../locales/locales_faq";

function FAQGenerator({ dictionary }) {
	const { locale } = useRouter();

	const dictionaryFaq = getFaqLocales(locale);

	const questionsData = [
		{
			id: 1,
			question: "How to turn a picture into a painting?",
			answer: dictionary["In case you want to get a stunning art you just need to upload your image and AI will do the magic"],
		},
		{
			id: 2,
			question: "Is it free?",
			answer: dictionary["faq"]["answer_free"],
		},
		{
			id: 3,
			question: "How to get the best result?",
			answer: dictionary["our converter works better with landscapes"],
		},
		{
			id: 4,
			question: "Photos of which formats can I upload?",
			answer: dictionary["We support photos of image formats"],
		},
		{
			id: 5,
			question: "Can I save the painting I created?",
			answer: dictionary["faq"]["Yes, any user can download and save it"],
		},
		{
			id: 6,
			question: "What tariffs users can use this service?",
			answer: dictionary["faq"]["The service is available for users of all tariffs"],
		},
		{
			id: 7,
			question: "Where the created images can be used?",
			answer: dictionary["Your artworks will look great as the illustrations or as posts on your social media"],
		},
		{
			id: 8,
			question: "Why the result didn’t meet my expectations?",
			answer: dictionary["ai we utilize may generate inaccuracies"],
		},
	];
	const [openQuestions, setOpenQuestion] = useState([]);
	const checkActiveQuestion = (id) => {
		return openQuestions.includes(id);
	};
	const toggleQuestion = (id) => {
		checkActiveQuestion(id)
			? setOpenQuestion((prev) => {
					return prev.filter((item) => {
						return item !== id;
					});
			  })
			: setOpenQuestion((prev) => {
					return [...prev, id];
			  });
	};

	return (
		<section className={style.block}>
			<h2 className={style.title}>{dictionaryFaq["page title"]}</h2>
			<div className={style.container}>
				{questionsData.map((item) => (
					<div onClick={() => toggleQuestion(item.id)} key={item.id} className={style.item}>
						<div className={`${style.question} ${checkActiveQuestion(item.id) ? style.active : ""}`}>
							<h3>{dictionary["fag"][item.question] || dictionary["faq"][item.question] || dictionary[item.question] || item.question}</h3>
							<ArrowIcon className={style.arrow} />
						</div>
						<div className={style.answer}>
							<div>{item.answer}</div>
						</div>
					</div>
				))}
			</div>
		</section>
	);
}

export default FAQGenerator;
